module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am2_m.d5cdf05bfd749ef59feebe1891cd6fe4.png";